<template>
    <v-chart  
    style="width:90%;height:280px;"
    :auto-resize="true"
    ref="chart1"/>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { PieChart  } from "echarts/charts";
// import ECharts from 'echarts';
import {
    ToolboxComponent,
    TooltipComponent,
    LegendComponent,
    GridComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";
use([
    GridComponent,
    CanvasRenderer,
    PieChart,
    ToolboxComponent,
    TooltipComponent,
    LegendComponent,
]);
export default {
    name:'chartinvestments',
    components:{
        VChart
    },
    provide: {
        [THEME_KEY]: "light"
    },
    props:{
       combine_names_values:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       isfund:{
           type:Boolean,
           required:true,
           default:()=>{
               return false
           }
       }
    },
    created(){
        setTimeout(()=>{
            this.setoption();
        },1000)
        
    },
    mounted() {
        this.$nextTick(()=>{
            this.$refs.chart1.clear();
            this.setoption();
            window.addEventListener("resize", this.resizeTheChart);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeTheChart);
    },
    methods:{
        resizeTheChart() {
            if (this.$refs.chart1) {
                this.$refs.chart1.resize();
            }
        },
        setoption(){
            this.$refs.chart1.setOption(this.option, true);
        }
    },
    data(){
        return{
            option: {
                toolbox: {
                    show: this.isfund?false:true,
                    feature: {
                        mark: {show: true},
                        dataView: {show: true, readOnly: true},
                        restore: {show: true},
                        saveAsImage: {show: true},
                        // magicType: {
                        //     type: ['line', 'bar', 'stack']
                        // }
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} :<span style="color:black"> ${c}</span> ({d}%)'
                },
                series: [
                    {
                        name:'Investments',
                        type: 'pie',
                        radius: ['40%','80%'],
                        center: ['50%', '50%'],
                        // roseType: 'area',
                        itemStyle: {
                            // borderRadius: 8,
                            opacity: this.isfund? 0.5:0.8,
                            color:function(params) {
                                let colorList = [           
                                        '#8ECAE6','#4895EF','#4361EE','#3F37C9',                                    
                                        '#6247aa','#815ac0','#9381ff','#b8b8ff','#cbc0d3',
                                        '#efd3d7','#eee2df'                                        
                                ];
                                return colorList[params.dataIndex]
                            }
                            
                        },
                        label: {
                            show: false
                        },
                        data: this.combine_names_values,
                        
                    }
                ]
            }
        }
    }
}
</script>